import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import RichTextEditor from "react-rte";
import QuickReadPreview from "../../popup/quickReadPreview/QuickReadPreview";

const UpdateBlog = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const editor = useRef(null);

  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [category, setCategory] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [images, setImages] = useState(null);
  const [coverImage, setCoverImage] = useState(null);
  const [oldBlog, setOldBlog] = useState({});
  const [previewModal, setPreviewModal] = useState(false);
  const [editorValue, setEditorValue] = useState(RichTextEditor.createEmptyValue());

  useEffect(() => {
    axios
      .get(`https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/get/blog/${id}`)
      .then((res) => {
        console.log(res.data)
        setOldBlog(res.data.data);
        setTitle(res.data.data.title);
        setSubtitle(res.data.data.subtitle);
        setCategory(res.data.data.category);
        setMetaDescription(res.data.data.metaDescription);
        setIsActive(res.data.data.isActive);
        // setCoverImage(res.data.Blog.thumbnail);
        if (res.data.data.description) {
            setEditorValue(
              RichTextEditor.createValueFromString(res.data.data.description, "html")
            );
        }

      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  const handleChange = (value) => setEditorValue(value);

  const handlePreviewClick = (e) => {
    e.preventDefault();
    setPreviewModal(true);
  };

//   const uploadImage = async ({ target }) => {
//     setDisableButton(true);
//     const files = target.files;
//     const formData = new FormData();
//     for (let i = 0; i < files.length; i++) {
//       const originalName = files[i].name;
//       const modifiedName = originalName.includes("Slide")
//         ? originalName
//         : `Slide ${originalName}`;
//       formData.append("images", new File([files[i]], modifiedName));
//     }
//     try {
//       const response = await axios.post(
//         "https://your-api.com/blogs/changeImageResolution/",
//         formData
//       );
//       setImages(response.data.urlData);
//     } catch (error) {
//       console.error(error);
//     }
//     setDisableButton(false);
//   };

  const uploadCoverImage = async ({ target }) => {
    setDisableButton(true);
    const files = target.files;
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("images", files[i]);
    }
    try {
      const res = await axios.post(
        "https://qrs.btartisticyoga.com/magicFood/uploadImageToAWS/",
        formData
      );
      setCoverImage(res.data.urls[0]);
      console.log(res.data.urls[0])
    } catch (err) {
      console.error(err);
    }
    setDisableButton(false);
  };

  const updateBlog = async (e) => {
    e.preventDefault();
    const isEditorEmpty = editorValue.toString("html") === "<p><br></p>";
    if (!title || isEditorEmpty) {
      alert("Title and Content are required");
      return;
    }
    const obj = {
      title: title !== "" ? title : oldBlog.title,
      description: !isEditorEmpty
        ? editorValue.toString("html")
        : oldBlog?.description,
      subtitle: subtitle !== "" ? subtitle : oldBlog.subtitle,
    //   image: images !== null ? images : oldBlog.image,
      category: category !== "" ? category : oldBlog.category,
      coverImage: coverImage !== null ? coverImage : oldBlog.coverImage,
      metaDescription: metaDescription !== "" ? metaDescription : oldBlog.metaDescription,
      isActive: isActive
    };
    setDisableButton(true);
    await fetch(
      `https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/update/blog/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
        redirect: "follow",
      }
    )
      .then((response) => response.json())
      .then((result) => {
        alert("Blog updated successfully");
        navigate("/home");
      })
      .catch((error) => {
        console.log("error", error);
      });
    setDisableButton(false);
  };

  const isEditorEmpty = editorValue.toString("html") === "<p><br></p>";
  const isSubmitDisabled = disableButton || !title || isEditorEmpty;

  console.log(isSubmitDisabled, disableButton, !title, isEditorEmpty)

  return (
    <div className="Apps">
      <div className="breadcrumbcontainer">
        <div className="breadcrumb-nav">
          <img src="/assets/rightchevron.png" alt="" />
          <span>Update Blog</span>
        </div>
      </div>
      <form className="quickread_from" onSubmit={updateBlog}>
        <div className="mb-3">
          <label htmlFor="title" className="form-label">
            Title
            <span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="title"
            value={title}
            required
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="subtitle" className="form-label">
            Subtitle
          </label>
          <input
            type="text"
            className="form-control"
            id="subtitle"
            value={subtitle}
            onChange={(e) => setSubtitle(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="category" className="form-label">
            Category
          </label>
          <input
            type="text"
            className="form-control"
            id="category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          />
        </div>

        <div className="mb-4">
          <label htmlFor="category" className="form-label">
            Meta Description
          </label>
          <input
            type="text"
            className="form-control"
            id="metaDescription"
            value={metaDescription}
            onChange={(e) => setMetaDescription(e.target.value)}
          />
        </div>


        <div className="mb-3 d-flex gap-2 align-items-center">
         
          <input

             type="checkbox"
             id="isActive"
             checked={isActive}
             onChange={(e) => {
               setIsActive(e.target.checked);
             }}
          />
           <label htmlFor="category" className="form-label">
            Is Blog Active
          </label>
        </div>

        <div className="mb-3">
          <label htmlFor="coverImage" className="form-label">
            Thumbnail Image
          </label>
          <input
            type="file"
            className="form-control"
            id="coverImage"
            onChange={uploadCoverImage}
          />
        </div>
        {/* <div className="mb-3">
          <label htmlFor="files" className="form-label">
            Images
          </label>
          <input
            type="file"
            className="form-control"
            id="files"
            onChange={uploadImage}
            multiple
          />
        </div> */}
        <div className="mb-3">
          <label htmlFor="desc" className="form-label">
            Content<span className="required">*</span>
          </label>
          <RichTextEditor
            className="rich-text-editor"
            toolbarClassName="editor-toolbar"
            value={
              editorValue
            }
            onChange={handleChange}
          />
        </div>
        <button
          className="quickRead__previewButton"
          onClick={handlePreviewClick}
          type="button"
        >
          Preview
        </button>
        <input
          disabled={isSubmitDisabled}
          className="submitBtn"
          type="submit"
          value="Submit"
        />
      </form>
      <QuickReadPreview
        show={previewModal}
        onHide={() => setPreviewModal(false)}
        desc={
          !isEditorEmpty
            ? editorValue.toString("html")
            : oldBlog?.description
        }
        images={images != null ? images : oldBlog?.imageAssets}
        title={title !== "" ? title : oldBlog?.title}
      />
    </div>
  );
};

export default UpdateBlog;